module.exports = __webpack_public_path__ + "img/logo-panel2.dcb3d0d1.png";